// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-picker.v-sheet {
  display: grid;
  grid-auto-rows: min-content;
  grid-template-areas: "header" "body";
  grid-template-columns: minmax(0, 1fr);
  overflow: hidden;
}
:where(.vuetify-styles) .v-picker.v-sheet {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-picker.v-sheet {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-picker.v-sheet.v-picker--with-actions {
  grid-template-areas: "header" "body" "actions";
}
:where(.vuetify-styles) .v-picker.v-sheet.v-picker--landscape {
  grid-template-columns: auto 1fr;
  grid-template-areas: "header body" "header body";
}
:where(.vuetify-styles) .v-picker.v-sheet.v-picker--landscape.v-picker--with-actions {
  grid-template-areas: "header body" "header actions";
}

:where(.vuetify-styles) .v-picker__body {
  grid-area: body;
  overflow: hidden;
  position: relative;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

:where(.vuetify-styles) .v-picker__header-wrapper {
  grid-area: header;
}

:where(.vuetify-styles) .v-picker__actions {
  grid-area: actions;
  padding: 0 12px 12px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
:where(.vuetify-styles) .v-picker__actions .v-btn {
  min-width: 48px;
}
:where(.vuetify-styles) .v-picker__actions .v-btn:not(:last-child) {
  margin-inline-end: 8px;
}

:where(.vuetify-styles) .v-picker--divided .v-picker__header {
  border-bottom-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-bottom-style: solid;
  border-bottom-width: thin;
}

:where(.vuetify-styles) .v-picker-title {
  text-transform: uppercase;
  font-size: 0.75rem;
  padding-inline: 24px 12px;
  padding-top: 16px;
  padding-bottom: 16px;
  font-weight: 400;
  letter-spacing: 0.1666666667em;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VPicker/VPicker.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;EACpC,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+BAA+B;EAC/B,gDAAgD;AAClD;AACA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC","sourcesContent":[".v-picker.v-sheet {\n  display: grid;\n  grid-auto-rows: min-content;\n  grid-template-areas: \"header\" \"body\";\n  grid-template-columns: minmax(0, 1fr);\n  overflow: hidden;\n}\n.v-picker.v-sheet {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-picker.v-sheet {\n  border-radius: 4px;\n}\n.v-picker.v-sheet.v-picker--with-actions {\n  grid-template-areas: \"header\" \"body\" \"actions\";\n}\n.v-picker.v-sheet.v-picker--landscape {\n  grid-template-columns: auto 1fr;\n  grid-template-areas: \"header body\" \"header body\";\n}\n.v-picker.v-sheet.v-picker--landscape.v-picker--with-actions {\n  grid-template-areas: \"header body\" \"header actions\";\n}\n\n.v-picker__body {\n  grid-area: body;\n  overflow: hidden;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.v-picker__header-wrapper {\n  grid-area: header;\n}\n\n.v-picker__actions {\n  grid-area: actions;\n  padding: 0 12px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.v-picker__actions .v-btn {\n  min-width: 48px;\n}\n.v-picker__actions .v-btn:not(:last-child) {\n  margin-inline-end: 8px;\n}\n\n.v-picker--divided .v-picker__header {\n  border-bottom-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-bottom-style: solid;\n  border-bottom-width: thin;\n}\n\n.v-picker-title {\n  text-transform: uppercase;\n  font-size: 0.75rem;\n  padding-inline: 24px 12px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  font-weight: 400;\n  letter-spacing: 0.1666666667em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
